import { selector } from '@glitz/core';
import { styled } from '@glitz/react';

export const scrollbarDecorator = styled(
  selector('::-webkit-scrollbar', {
    width: 4,
  }),
  selector('::-webkit-scrollbar-track', {
    backgroundColor: t => t.scrollbar?.trackColor,
    borderRadius: t => t.scrollbar?.radius,
  }),
  selector('::-webkit-scrollbar-thumb', {
    backgroundColor: t => t.scrollbar?.thumbColor,
    borderRadius: t => t.scrollbar?.radius,
  }),
);

export const hideScrollbarDecorator = styled(
  selector('::-webkit-scrollbar', {
    display: 'none',
  }),
  {
    scrollbarWidth: 'none',
  },
);
